import React, { useEffect } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { Link, Row, HeadingText } from '@paypalcorp/pp-react'
import { getTitleForArticleUrl } from '../../utils/helper'
import { RECOMMENDED_SOLUTIONS_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

//Hooks
import { useHelper } from '../../hooks/useHelper'
import useTracking from '../../hooks/useTracking'

// styles
import './recommended-solutions.less'

// Recommended Solutions Component
function RecommendedSolutions({ recommendedSolutionsData }) {
  const { generateLinkWithCoBrand } = useHelper()
  const { trackActivity, trackClick } = useTracking()

  useEffect(() => {
    trackActivity({
      name: componentNames.RECOMMENDED_SOLUTIONS,
      type: fptiTypes.SUCCESS,
    })
  }, [])

  //  Recommended article on click handler
  const onClickHandler = (e, article) => {
    e.stopPropagation()
    trackClick({
      name: componentNames.RECOMMENDED_SOLUTIONS,
      type: fptiTypes.ON_CLICK,
      link: `recommended-solutions|${article.articleId}|clicked`,
    })
  }

  // render the recommended-soltions list
  const renderRecommendedSolutions = () => {
    return recommendedSolutionsData.map((article) => {
      const formattedTitle = () =>
        getTitleForArticleUrl(article.articleTitle, article.articleId)
      const articleUrl = generateLinkWithCoBrand(
        `/cshelp/article/${formattedTitle()}`,
      )

      return (
        <li
          onClick={(e) => onClickHandler(e, article)}
          key={article.articleId}
          data-testid="hc-recommended-solutions-list-item"
          className="hc-recommended-solutions__list-item"
        >
          <Link
            href={articleUrl}
            key={`article_${article.articleId}`}
            data-testid="hc-recommended-solutions-article-link"
          >
            {article.articleTitle}
          </Link>
        </li>
      )
    })
  }

  return (
    <div data-testid="hc-recommended-solutions-container">
      <Row>
        <HeadingText
          size="sm"
          data-testid="hc-recommended-solutions-heading-text"
          className="hc-recommended-solutions__heading"
        >
          <Message id="app.helpcenter.commonQuestions" />
        </HeadingText>
      </Row>
      <ul
        data-testid="hc-recommended-solutions-list"
        className="hc-recommended-solutions__list"
      >
        {renderRecommendedSolutions()}
      </ul>
    </div>
  )
}

RecommendedSolutions.propTypes = RECOMMENDED_SOLUTIONS_DATA

export default RecommendedSolutions
